import Vue from 'vue'
import createRouter from 'vue-router'

// 路由页面导入
// import index from '../pages/index/index.vue' //首页
// var main = res => require(['@/components/comps/main.vue'], res)


Vue.use(createRouter)
const router = new createRouter({
  routes: [
    {
      path: '/login',
      // name: '菜单栏',
      component: (resolve) => {
        require(['@/pages/login/login.vue'], resolve)
      },
    },
    {
      path: '/menu',
      // name: '菜单栏',
      component: (resolve) => {
        require(['@/components/menu.vue'], resolve)
      },
      children: [
        {
          path: '/bandlist',
          name: '品牌列表',
          meta: {
            keepAlive: true
          },
          component: (resolve) => {
            require(['@/pages/brand/brandlist.vue'], resolve)
          },
        },
        {
          path: '/agentlist',
          name: '站点列表',
          meta: {
            // keepAlive: true
          },
          component: (resolve) => {
            require(['@/pages/agent/agentlist.vue'], resolve)
          },
        },
        {
          path: '/userslist',
          name: '用户列表',
          meta: {
            keepAlive: true
          },
          component: (resolve) => {
            require(['@/pages/users/userslist.vue'], resolve)
          },
        },
        {
          path: '/dataplist',
          name: '权限列表',
          meta: {
            keepAlive: true
          },
          component: (resolve) => {
            require(['@/pages/datapermission/dataplist.vue'], resolve)
          },
        },
        {
          path: '/usermanage',
          name: '账号管理',
          meta: {
            keepAlive: true
          },
          component: (resolve) => {
            require(['@/pages/setting/usermanage/index.vue'], resolve)
          },
        },
        {
          path: '/authority',
          name: '权限管理',
          meta: {
            keepAlive: true
          },
          component: (resolve) => {
            require(['@/pages/setting/authority/index.vue'], resolve)
          },
        }
      ]
    },
    {
      path: '*',
      redirect: {
        name: '',
        path: '/bandlist',
      }
    },
    // 登录

  ]


});
router.beforeEach((to, from, next) => {

  
  next();
});
export default router